import {Directive, HostListener} from "@angular/core";

@Directive({
    selector: "[mouse-stop-propagation]",
    standalone: false
})
export class MouseStopPropagation
{
    @HostListener("click", ["$event"])
    public onClick(event: any): void
    {
      event.stopPropagation();
    }
    @HostListener("mousedown", ["$event"])
    public onMouseDown(event: any): void
    {
      event.stopPropagation();
    }
}
